<app-banner [loading]="loading" [info]="true" [heading]="'Notifications'" [subHeading]="'View all notifications received from premises.'">


  <div class="toolbar-content">

    @if (!layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(true)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-maximize"></i>
        <span>maximise</span>
      </button>
    }

    @if (layout.state.fullscreen) {
      <button (click)="layout.setFullscreen(false)" aria-label="Maximise" class="btn btn-back">
        <i class="fa fa-window-restore"></i>
        <span>restore</span>
      </button>
    }


  </div>

</app-banner>
<app-collapsible [trigger]="searchVisible">
  <div class="content no-boxes search-bar">


    <div style="flex-grow: 1">
      <div class="form-inline reg-number">
        <input #ownerNo (keydown.enter)="search()" placeholder="Owner number..." [(ngModel)]="ownerNumber"
          type="text" name="ownerNo" class="form-control " />
          <button class="btn btn-primary ml-2" [disabled]="!ownerNumber" (click)="search()">Search</button>
          <button class="btn btn-default ml-2" [disabled]="!ownerNumber" (click)="clearSearch()">Clear</button>
        </div>
      </div>

    </div>

  </app-collapsible>

  @if (!loading) {
    <div class="content no-boxes fadein">
      @if (notifications) {
        <div style="padding-bottom: 20px">
          <h4>Notifications sent to {{ ownerName }}</h4>
          <table class="table">
            <thead>
              <tr>
                <th style="width: 100px">Date of Notification</th>
                <th style="width: 200px">Notification type</th>
                <th style="width: 100px"></th>
              </tr>
            </thead>
            <tbody>
              @for (notification of notifications | searchPipe:notificationType; track notification; let i = $index) {
                <tr class="clickable">
                  <td> {{ notification.notificationDate | utcDate }} </td>
                  <td> {{ getNotificationType(notification.type) }} </td>
                  <td (click)="viewNotificationDetails(i)"> View </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
      @if (!notifications?.length) {
        <div class="no-data">
          @if (!errorMessage) {
            <p>There are currently no notifications to display</p>
          }
          @if (!!errorMessage) {
            <p>{{errorMessage}}</p>
          }
        </div>
      }
    </div>
  }